import { useCallback, useState } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { change, changeBenefits, changeAttachment, getContractForm, postContractForm } from 'app/store/modules/hsContracts';
import * as api from 'app/api';
import { closeKakaoInAppBrowser } from 'app/libs/snsUtils';

export default function useContracts() {
	const { isInitRequest, param, photoBlobs, targetInfo, confirmStatus, signatures, attachments } = useSelector(
		(state) => state.hsContracts,
		shallowEqual,
	);
	const dispatch = useDispatch();

	const changeInfo = useCallback((payload) => dispatch(change(payload)), [dispatch]);
	const changeBenefitInfo = useCallback((payload) => dispatch(changeBenefits(payload)), [dispatch]);
	const changeAttachInfo = useCallback((payload) => dispatch(changeAttachment(payload)), [dispatch]);

	const getContractFormInfo = useCallback((payload) => dispatch(getContractForm(payload)), [dispatch]);
	const postContract = useCallback((payload) => dispatch(postContractForm(payload)), [dispatch]);

	const [uploadPending, setUploadPending] = useState(false);
	const handleUpload = useCallback((file, contractKey, documentKey, type) => {
		setUploadPending(true);
		const body = new FormData();

		body.append('file', file);
		body.append('contractKey', contractKey);
		body.append('documentKey', documentKey);
		body.append('type', type);
		return api.postContractImg(body).finally(() => {
			setUploadPending(false);
		});
	}, []);

	const handleWinowClose = () => {
		const isKakaoTalk = window.navigator.userAgent.toLowerCase().indexOf('kakaotalk') !== -1;
		if (isKakaoTalk) {
			closeKakaoInAppBrowser();
		} else {
			window.self.close();
		}
	};

	const transformOrientationFile = (file) =>
		new Promise(async (resolve) => {
			const { default: loadImage } = await import('blueimp-load-image');
			loadImage(
				file,
				(img, data) => {
					const exifData = data.exif && data.exif.get('Orientation');
					let convertOrientation = true;
					switch (exifData) {
						case 1:
							convertOrientation = 6;
							break;
						case 3:
							convertOrientation = 8;
							break;
						default:
					}
					loadImage(
						file,
						(convertImg) => {
							convertImg.toBlob((blob) => {
								if (blob) {
									const newFile = new File([blob], file.name, { ...file });
									resolve(newFile);
								}
							}, file.type);
						},
						{
							canvas: 1,
							orientation: convertOrientation,
							maxWidth: 1100,
						},
					);
				},
				{
					canvas: 1,
					orientation: true,
					meta: true,
				},
			);
		});

	return {
		isInitRequest,
		param,
		photoBlobs,
		targetInfo,
		signatures,
		attachments,
		changeInfo,
		changeBenefitInfo,
		changeAttachInfo,
		confirmStatus,
		getContractFormInfo,
		postContract,
		uploadPending,
		handleUpload,
		handleWinowClose,
		transformOrientationFile,
	};
}
